import jsonapi from 'jsonapi-parse';
import Invoice from '@/models/read/Invoice';

export default $axios => () => ({
    async index() {
        let response = await $axios.get(`/rest/finance/invoices`);
        return jsonapi.parse(response.data).data.map(i => new Invoice(i));
    },

    async forOrder(id) {
        let response = await $axios.get(`/rest/finance/invoices?orderId=${id}`);
        return jsonapi.parse(response.data).data.map(i => new Invoice(i));
    },
});
